const TOKEN_SEPARATOR = '#'

export const encodeBoundaryKey = <
  T extends { id: string; document_id: string }
>(
  page: T
) => `${page.id}${TOKEN_SEPARATOR}${page.document_id}`

export const decodeBoundaryKey = (key: string) => {
  const [pageId, document_id] = key.split(TOKEN_SEPARATOR)

  return {
    pageId,
    document_id,
  }
}
